import { createSlice } from '@reduxjs/toolkit'

export const ACTION_TYPE = {
  PREV: "prev",
  NEXT: "next"
}
const initialState = {
  activeStepperIndex: 0,
  actionType: ACTION_TYPE.NEXT,
}

export const sliceName = 'homeSlice'
export const homeSlice = createSlice({
  name: sliceName,
  initialState,
  reducers: {
    stepperMove: (state, action) => {
      if (state.activeStepperIndex < action.payload) {
        state.actionType = ACTION_TYPE.NEXT
      }
      else {
        state.actionType = ACTION_TYPE.PREV
      }
      state.activeStepperIndex = action.payload
    }
  },
})

// Action creators are generated for each case reducer function
export const { stepperMove } = homeSlice.actions
export const selectActiveStepperIndex = (state) => state[sliceName].activeStepperIndex
export const selectActionType = (state) => state[sliceName].actionType

export default homeSlice.reducer